<template>
    <div id="user_logs_layout">
        <transition v-if="is_initialized" name="slide-fade" mode="out-in" appear>
            <router-view>
            </router-view>
        </transition>
        <div v-else class="ui active centered inline large loader"></div>
    </div>
</template>

<script>
export default {
    name: "UserLogsLayout",
    data() {
        return {
            is_initialized: false,
            errors: [],
        }
    },
    computed: {
    },
    created() {
        this.init()
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
    },
    components: {
    }
}
</script>
